<template>
  <div id="switchdev">
    <div id="entity">
      <h1>{{ entityName }}</h1>
      <v-img id="logo" v-bind:src="logoUrl"> </v-img>
      <br />
    </div>
    <div id="roomname">
      <b>{{ roomName }}</b>
    </div>
    <div v-if="isRoomTimingsViewEnabled" id="roominfo">
      <b>{{ $t('message.switching.date') }}</b
      >: {{ getDate(startDate) }}
      <br />
      <b>{{ $t('message.switching.startTime') }}</b
      >: {{ getHour(startDate) }}
      <br />
      <b>{{ $t('message.switching.endTime') }}</b
      >: {{ getHour(endDate) }}
    </div>
    <div v-else id="roominfo">
      <b>{{ $t('message.switching.date') }}</b
      >: {{ getDate(startDate) }}
      <br />
      <br />
    </div>
    <div id="switchmsg">
      <p>{{ $t('message.switching.message') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /* Información del participante y sala */
    userId: String,
    roomId: String,
    token: String,
    /* Información de la sala */
    entityName: String,
    logoUrl: String,
    role: String,
    roomName: String,
    startTimestamp: Number,
    endTimestamp: Number,
    roomStatus: Number,
    isRoomTimingsViewEnabled: Boolean
  },
  computed: {
    startDate: function() {
      return new Date(this.startTimestamp * 1000);
    },
    endDate: function() {
      return new Date(this.endTimestamp * 1000);
    }
  },
  methods: {
    getHour(date) {
      return date.toLocaleTimeString();
    },
    getDate(date) {
      return (
        date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
      );
    }
  }
};
</script>

<style>
#switchdev {
  padding: 3vh;
  transition: all 1s;
  height: 100vh;
  display: flex;
  display: webkit-flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}

#entity {
  text-align: center;
}

#logo {
  max-width: 180px;
  width: 50vw;
  display: block;
  margin: 0 auto;
}

#roomname {
  text-align: center;
  margin-top: 5vw;
}

#roominfo {
  margin-top: 5vw;
}

#switchmsg {
  margin-top: 5vw;
  text-align: center;
  font-size: 1.2em;
  font-weight: bold;
  color: green;
}
</style>
